import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=68c96ad2&scoped=true&"
import script from "./weixin.vue?vue&type=script&lang=js&"
export * from "./weixin.vue?vue&type=script&lang=js&"
import style0 from "./weixin.vue?vue&type=style&index=0&id=68c96ad2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c96ad2",
  null
  
)

export default component.exports